import { IconProps } from '../../types/IconProps';

export const Search = ({ variant, className }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    fill='none'
    className={`${className || ''}`}>
    <g clipPath='url(#a)'>
      <path
        fill={variant === 'light' ? '#fff' : '#0B223E'}
        d='m21.1 19.989-4.477-4.477c3.881-4.66 1.263-11.775-4.714-12.807C5.932 1.674 1.079 7.5 3.175 13.191c1.88 5.11 8.253 6.817 12.436 3.333L20.088 21a.716.716 0 0 0 1.012-1.012Zm-16.96-9.51c0-4.956 5.366-8.053 9.658-5.575 4.292 2.478 4.292 8.673 0 11.151a6.44 6.44 0 0 1-3.22.863A6.446 6.446 0 0 1 4.14 10.48Z'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M2 1.9h20v20H2z' />
      </clipPath>
    </defs>
  </svg>
);
